export default "__VITE_ASSET__C755kGU1__"